export default "__VITE_ASSET__HH3nR1FV__"